// The films the sites lay over a photograph so white copy keeps its contrast
// — the brand's washes, named after where each began: the Sanctuary home
// hero's deep green, the same depth in the palette's darkest navy, and the
// page heroes' lighter navy. Every band that puts copy over a picture (the
// heroes, the CTA bands, the resident-therapist band, the footers) reads them
// from here, and the admin picks between them per section — the values are
// PageContentRegistry::FILMS.
//
// Three stops rather than a flat wash: heaviest top and bottom, where the
// copy sits, lightest across the middle so the picture is still a picture.
export const FILMS: Record<string, string> = {
  navy: "linear-gradient(to bottom, rgba(95,116,147,0.88) 0%, rgba(95,116,147,0.78) 60%, rgba(95,116,147,0.88) 100%)",
  deep: "linear-gradient(to bottom, rgba(15,43,48,0.85) 0%, rgba(15,43,48,0.70) 60%, rgba(15,43,48,0.85) 100%)",
  // The green's twin in blue: brand-navy hue (216°, as --color-navy) at the
  // green's own saturation and — the point of it — its perceptual lightness,
  // CIE L* 16 against the green's 15.7. Matching HSL lightness instead looks
  // half as bright, because a blue puts its light in the channel the eye
  // weighs least: --color-navy-deep was L* 7.5 and read as a black band.
  blue: "linear-gradient(to bottom, rgba(21,40,68,0.85) 0%, rgba(21,40,68,0.70) 60%, rgba(21,40,68,0.85) 100%)",
}

/** The CSS for a stored film name. The server sends one for every section
 *  that can carry a photo; navy is the fallback for anything else. */
export function filmStyle(name?: string | null): string {
  return (name && FILMS[name]) || FILMS.navy
}

/**
 * The film for a card rather than a band. A hero's three stops keep the middle
 * of a photograph visible because nothing is written across it; a card's copy
 * runs its whole height, so that light middle lands under the middle
 * paragraphs. The same blue, flat and a shade heavier, holds white text evenly
 * from the first line to the last.
 */
export const CARD_FILM =
  "linear-gradient(rgba(21,40,68,0.88), rgba(21,40,68,0.88))"
